import { defineStore } from 'pinia'
import {
   demoProfiles,
   appointments as mockAppointments,
   incidents as mockIncidents,
   diaryEntries as mockDiaryEntries,
   activityEvents as mockActivityEvents,
   registryEntries as mockRegistryEntries,
   alertReads as mockAlertReads,
   guestTransferRequests as mockTransferRequests,
   operatorAttachments as mockOperatorAttachments,
   guestAttachments as mockGuestAttachments,
} from '~/composables/useMockData'

export const useDemoStore = defineStore('demo', () => {
   const currentProfileId = ref(demoProfiles[0]!.id)

   const currentProfile = computed(() => {
      return demoProfiles.find((p) => p.id === currentProfileId.value) || demoProfiles[0]!
   })

   function setProfile(id: string) {
      currentProfileId.value = id
   }

   const allAppointments = ref([...mockAppointments])
   const allIncidents = ref([...mockIncidents])
   const allDiaryEntries = ref([...mockDiaryEntries])
   const allActivityEvents = ref([...mockActivityEvents])
   const allRegistryEntries = ref([...mockRegistryEntries])
   const allAlertReads = ref([...mockAlertReads])
   const localGuests = ref<any[]>([])
   const localGuestServices = ref<any[]>([])
   const localGuestUnits = ref<Record<string, string>>({})
   const allTransferRequests = ref([...mockTransferRequests])
   const allOperatorAttachments = ref([...mockOperatorAttachments])
   const allGuestAttachments = ref([...mockGuestAttachments])
   const archivedGuestIds = ref<Set<string>>(new Set())

   return {
      currentProfileId,
      currentProfile,
      setProfile,
      allAppointments,
      allIncidents,
      allDiaryEntries,
      allActivityEvents,
      allRegistryEntries,
      allAlertReads,
      localGuests,
      localGuestServices,
      localGuestUnits,
      allTransferRequests,
      allOperatorAttachments,
      allGuestAttachments,
      archivedGuestIds,
   }
})
